import React from "react";
import PlayerItemSmall from "../player/small";
import { formatName } from "../../../libs/formatName";
import { Player } from "../../../types";
import cx from "classnames";

const ReservationItemLarge = ({
	date,
	club,
	court,
	sport,
	partners,
	className,
}: {
	date: any;
	club: string;
	court: string;
	sport: string;
	partners: any;
	className?: string;
}) => (
	<div className={cx("item", "reservation", "large", className)} data-number-of-partners={partners.length}>
		<div className="date">
			<div className="dateDay">{date.format("D")}</div>
			<div className="dateMonth">{date.format("MMM")}</div>
		</div>
		<div className="itemBody">
			<div className="title">
				{date.format("HH:mm")} at {club}
			</div>
			<div className="meta">
				{court} ({sport})
			</div>
		</div>
		<div className="partners">
			{partners.map((player: Player, index: number) => (
				<PlayerItemSmall
					key={index}
					name={player.fullName ? player.fullName : formatName(player.firstName, player.lastName)}
					photoUrl={player.photoUrl}
				/>
			))}
		</div>
	</div>
);

export default ReservationItemLarge;
